 import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Dropdown, DropdownButton, Form, Modal, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import DataTable from 'react-data-table-component';
import { SearchIcon } from '@primer/octicons-react';
import { BiDownload, BiHelpCircle, /*BiTrash,*/ BiPlus, BiXCircle } from "react-icons/bi";
import { MdOutlineFileDownloadOff } from "react-icons/md";
import PurgeConfirmDialog from './DeleteConfirmDialog';
import DeleteConfirmDialog from './DeleteConfirmDialog';
import { axiosAuth_DATA_MGMT_API, axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import { translateAPIError } from '../utils/apiUtils';
//import { hasAnyPerm } from '../utils/uiUtils';
import classes from './AdminPages.module.css';
import { formatDate } from '../utils/timeUtils';


const BatchDataProcAdminListView = (props) => {

  const { t } = useTranslation(['common', 'custom']);

  const [errMsg,                  setErrMsg]                  = useState('');
  const [notFoundMsg,             setNotFoundMsg]             = useState('');

  const [searchTerms,             setSearchTerms]             = useState();

  const [entityList,              setEntityList]              = useState();

  const [,                        setLoading]                 = useState(false);

  const [docMgmtConfig,           setDocMgmtConfig]           = useState(null);

  const [showPurgeConfirmDialog,  setShowPurgeConfirmDialog]  = useState(false);
  const [errMsgPurgeConfirm,      setErrMsgPurgeConfirm]      = useState('')

  const [showCancelConfirmDialog, setShowCancelConfirmDialog] = useState(false);
  const [cancelTarget,            setCancelTarget]            = useState();
  const [errMsgDeleteConfirm,     setErrMsgDeleteConfirm]     = useState('')

  const opOptions = [
    { key: "INSERT", value: "INSERT" },
    { key: "UPDATE", value: "UPDATE" },
    { key: "DELETE", value: "DELETE" },
    { key: "EXPORT", value: "EXPORT" }
  ];

  // ----- Data Table stuff - Import -----

  const [objList,   setObjList]   = useState([]);
  const [totalRows, setTotalRows] = useState();
  const [perPage,   setPerPage]   = useState(20);
  const [currPage,  setCurrPage]  = useState(1);
  const [sortCol,   setSortCol]   = useState(null);
  const [sortDir,   setSortDir]   = useState(null);

  const customStyles = {
    rows: {
      style: {
        minHeight: '25px', // override the row height
        fontSize: '11px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
      },
    },
  };

  const columns = [
    {
      name: t("I18N_ID"),
      selector: row => row.id,
      sortable: true,
      sortField: 'id',
      cell: row => (
        <span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleObjDetails(row)}>{row.id}</span>
      ),
      grow: 1
    },
    {
      name: t("I18N_Operation"),
      selector: row => t("I18N_" + row.operation),
      sortable: true,
      sortField: 'operation',
      grow: 1
    },
    {
      name: t("I18N_Target_entity"),
      selector: row => row.targetEntity,
      cell: row => (
        entityList && row.targetEntity ?
           (entityList.find( ({ code }) => code === row.targetEntity )).name
        : null
      ),
      sortable: true,
      sortField: 'targetEntity',
      grow: 2
    },
    {
      name: t("I18N_Comments"),
      selector: row => row.comments,
      wrap: true,
      grow: 3
    },
    {
      name: t("I18N_File_name"),
      selector: row => row.fileName,
/*
      sortable: true,
      sortField: 'fileName',
*/
      grow: 2
    },
    {
      name: <div style={{ whiteSpace: 'normal' }}>{t("I18N_Requester")}</div>,
      selector: row => row.creatorUsername,
      sortable: true,
      sortField: 'creatorUsername',
      grow: 1
    },
    {
      name: t("I18N_Req_time"),
      selector: row => formatDate(row.timeCreated),
      sortable: true,
      sortField: 'timeCreated',
      grow: 1.5
    },
    {
      name: t("I18N_Status"),
      selector: row => row.status,
      cell: row => (
        <>
        <span>{t("I18N_" + row.status)}</span>
        {(row.status === 'FAILED') && (row.error !== null) ?
            <OverlayTrigger overlay={<Tooltip id="tooltip-delete-req" style={{fontSize:'11px'}}>{t("I18N_" + row.error)}</Tooltip>}>
              <span style={{marginLeft:'10px', cursor:'pointer', color:'SteelBlue'}}>
                <BiHelpCircle size={15} />
              </span>
            </OverlayTrigger>
        : null
        }
        </>),
      sortable: true,
      sortField: 'status',
      grow: 1
    },
/*
    {
      name: t("I18N_Status_update_time"),
      selector: row => formatDate(row.statusTime),
      sortable: true,
      sortField: 'statusTime',
      grow: 1.5
    },
*/
    {
      name: '',
      selector: row => row.id,
      cell: row => (
        (row.status === 'PENDING') ?
          <OverlayTrigger overlay={<Tooltip id="tooltip-delete-req" style={{fontSize:'11px'}}>{t("I18N_TIP_Cancel_the_req")}</Tooltip>}>
            <span style={{cursor:'pointer', color:'SteelBlue'}}
                  onClick={() => handleCancelReq(row)}><BiXCircle size={16} />
            </span>
          </OverlayTrigger>
        :
        (row.status === 'SUCCESS') && (row.operation === 'INSERT') ?
          <>
          {(row.impResultUrl !== null) ?
            <OverlayTrigger overlay={<Tooltip id="tooltip-delete-req" style={{fontSize:'11px'}}>{t("I18N_TIP_Download_imp_data_w_id")}</Tooltip>}>
              <span style={{cursor:'pointer', color:'SteelBlue'}}
                    onClick={() => handleDownloadData(row)}><BiDownload size={16} />
              </span>
            </OverlayTrigger>
           :
            <OverlayTrigger overlay={<Tooltip id="tooltip-delete-req" style={{fontSize:'11px'}}>{t("I18N_Imp_result_expired")}</Tooltip>}>
              <span style={{cursor:'pointer', marginRight:'10px'}}>
                <MdOutlineFileDownloadOff size={16} />
              </span>
            </OverlayTrigger>
           }
           </>
        :
        (row.status === 'SUCCESS') && (row.operation === 'EXPORT') ?
          <>
          {(row.expOutputUrl !== null) ?
            <OverlayTrigger overlay={<Tooltip id="tooltip-delete-req" style={{fontSize:'11px'}}>{t("I18N_TIP_Download_exp_data")}</Tooltip>}>
              <span style={{cursor:'pointer', color:'SteelBlue'}}
                    onClick={() => handleDownloadData(row)}><BiDownload size={16} />
              </span>
            </OverlayTrigger>
           :
            <OverlayTrigger overlay={<Tooltip id="tooltip-delete-req" style={{fontSize:'11px'}}>{t("I18N_Exp_output_expired")}</Tooltip>}>
              <span style={{cursor:'pointer', marginRight:'10px'}}>
                <MdOutlineFileDownloadOff size={16} />
              </span>
            </OverlayTrigger>
           }
           </>
        :
        ((row.status === 'FAILED') ?
          <>
          {(row.error === 'ERR_See_err_report') ?
            ((row.errReportUrl !== null) ?
              <OverlayTrigger overlay={<Tooltip id="tooltip-delete-req" style={{fontSize:'11px'}}>{t("I18N_TIP_Download_err_rpt")}</Tooltip>}>
                <span style={{cursor:'pointer', color:'SteelBlue', marginRight:'10px'}}
                      onClick={() => handleDownloadData(row)}><BiDownload size={16} />
                </span>
              </OverlayTrigger>
            :
              <OverlayTrigger overlay={<Tooltip id="tooltip-delete-req" style={{fontSize:'11px'}}>{t("I18N_Err_report_expired")}</Tooltip>}>
                <span style={{cursor:'pointer', marginRight:'10px'}}>
                  <MdOutlineFileDownloadOff size={16} />
                </span>
              </OverlayTrigger>
            )
          : null
          }
{/*
          {(row.error !== null) ?
            <OverlayTrigger overlay={<Tooltip id="tooltip-delete-req" style={{marginLeft:'20px', fontSize:'11px'}}>{t(row.error)}</Tooltip>}>
              <span style={{cursor:'pointer', color:'SteelBlue'}}>
                <BiHelpCircle size={15} />
              </span>
            </OverlayTrigger>
          : null}
*/}
          </>
        : null)
      ),
      grow: 1
    },
  ];


  const handlePageChange = newCurrPage => {
    setCurrPage(newCurrPage);

    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    newCurrPage});

    fetchObjs(searchTerms, sortCol, sortDir, perPage, newCurrPage);
  };


  const handlePerRowsChange = async (newPerPage) => {

    setPerPage(newPerPage);

    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     newPerPage,
                          currPage:    1});

    fetchObjs(searchTerms, sortCol, sortDir, newPerPage, 1);
  };


  const handleSort = (column, sortDir) => {

    // instead of setTimeout this is where you would handle your API call.
    setSortCol (column.sortField);
    setSortDir (sortDir);

    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     column.sortField,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    1});

    fetchObjs(searchTerms, column.sortField, sortDir, perPage, 1);
  };

  const paginationComponentOptions={
          rowsPerPageText: t("I18N_Rows_per_page"),
          rangeSeparatorText: t("I18N_Pagination_page_of_total"),
          noRowsPerPage: false,
          selectAllRowsItem: false,
          selectAllRowsItemText: 'All'
        };

  // ----- END - Data Table stuff - Import -----


  // Initialize state
  useEffect(() => {

    // --- Import ---
    setSearchTerms(props.pageState.searchTerms);
    setSortCol(props.pageState.sortCol);
    setSortDir(props.pageState.sortDir);
    setPerPage(props.pageState.perPage);
    setCurrPage(props.pageState.currPage);

    fetchObjs(props.pageState.searchTerms, props.pageState.sortCol, props.pageState.sortDir, props.pageState.perPage,
              props.pageState.currPage);

    fetchBatchProcEntities();

    fetchDocMgmtConfig();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const fetchBatchProcEntities = async () => {

    try {
      const res = await axiosAuth_PLATFORM_API.get("business-configs?name=BATCH_PROC_ENTITIES");

      if (!res.data || (res.data.length === 0) || !res.data[0].config || (res.data[0].config.length === 0)) {
        setErrMsg(t("I18N_No_search_result"));
      } else {
        setEntityList(res.data[0].config);
        setErrMsg('');
      }

    } catch (error) {
      if (!error.message || (error.message !== 'IGNORE')) {
        setErrMsg(t(translateAPIError(error)));
      }
    }
  };


  const fetchObjs = async (searchTerms, sortCol, sortDir, perPage, currPage) => {

    try {
      setLoading(true);

      const res = await axiosAuth_DATA_MGMT_API.get("batch-data-proc-reqs?searchTerms=" +
                                                     ((searchTerms && (searchTerms !== null)) ? encodeURIComponent(searchTerms) : '') +
                                                     ((sortCol     && (sortCol     !== null)) ? ("&sortColumn=" + sortCol + "&sortDirection=" + sortDir) : '')  +
                                                     ((perPage     && (perPage     !== null)) ? ("&limit="      + perPage)                               : '')  +
                                                     ((currPage    && (currPage    !== null)) ? ("&offset="     + (currPage - 1) * perPage)              : ''));

      if (res.data.data.length === 0) {
        setNotFoundMsg("I18N_No_search_result");
      } else {
        setNotFoundMsg('');
      }

      setObjList(res.data.data);

      setTotalRows(res.data.total);
      setLoading(false);
      setErrMsg('');
    } catch (error) {
      if (!error.message || (error.message !== 'IGNORE')) {
        setErrMsg(t(translateAPIError(error)));
      }
    }
  }


  const fetchDocMgmtConfig = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("business-configs?name=DOC_MANAGEMENT");

        resolve(res.data);

        if (res.status === 200) {
          setDocMgmtConfig(res.data[0].config);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  // ----- Import Export Dialog stuff -----

  const [showNewReqDialog, setShowNewReqDialog] = useState(false);
  const [newReqAttrs,      setNewReqAttrs]      = useState({
                                                    targetEntity: '',
                                                    fileName: '',
                                                    comments: ''
                                                  });
  const [errMsg_NewReqDialog, setErrMsg_NewReqDialog] = useState('');


  function handleNewReqDialogCancel() {
    setErrMsg_NewReqDialog('');

    setNewReqAttrs ({
      targetAEntity: '',
      comments: ''
    });

    setShowNewReqDialog(false);
  }

  function handleNewReqDialogSubmit() {
    setErrMsg_NewReqDialog('');

    handleBatchProcReqSubmit();
  }


  const onNewReqInputChange = (e) => {
    setNewReqAttrs({ ...newReqAttrs, [e.target.name]: e.target.value  })
  }


  const onInputChange = (e, mode) => {
    setSearchTerms(e.target.value);
  }

  const handleSearchClear = ()  => {
    setSearchTerms('');

    setCurrPage(1); // Reset to page 1 for a fresh search
    props.onSetPageState({searchTerms: '',
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    1});

    fetchObjs('', sortCol, sortDir, perPage, 1);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    setCurrPage(1); // Reset to page 1 for a fresh search
    props.onSetPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    1});

    fetchObjs(searchTerms, sortCol, sortDir, perPage, 1);
  }


  function handleObjDetails(req) {
    req.targetEntityName = (entityList.find( ({ code }) => code === req.targetEntity )).name;

    props.onUIMode('DETAILS', req);
  }

  const handleNewReq = () => {

    setNewReqAttrs({
                    targetEntity: '',
                    operation: '',
                    fileName: '',
                    comments: ''
                  });

    setShowNewReqDialog(true);
  }


  // --- Purge Files ---
  const handlePurge = () => {
    setErrMsgPurgeConfirm('');
    setShowPurgeConfirmDialog(true);
  }

  function handlePurgeCancel() {
    setShowPurgeConfirmDialog(false);
  }

  function handlePurgeSubmit() {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("batch-data-proc-purge/");

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setShowPurgeConfirmDialog(false);
          setErrMsgPurgeConfirm('');
        }
      } catch (error) {
        setErrMsgPurgeConfirm(t(translateAPIError(error)));
      }
    });
  }


  // Import Confirm Dialog stuff

  // --- New Request ---

  function handleBatchProcReqSubmit() {

    // Validate parameters
    if ((newReqAttrs.operation === null) || (newReqAttrs.operation.trim().length === 0)) {
      setErrMsg_NewReqDialog(t('I18N_ERR_Need_op'));
      return;
    } else if ((!newReqAttrs.targetEntityObj) || (newReqAttrs.targetEntityObj === null)) {
      setErrMsg_NewReqDialog(t('I18N_ERR_Need_entity'));
      return;
    }

    if (newReqAttrs.operation !== 'EXPORT') {
      if ((newReqAttrs.fileName === null) || (newReqAttrs.fileName.trim().length === 0)) {
        setErrMsg_NewReqDialog(t('I18N_ERR_Need_data_file'));
        return;
      }
    }

    if (newReqAttrs.comments && (newReqAttrs.comments.length > 250)) {
      setErrMsg_NewReqDialog(t('I18N_ERR_Max_len_comments') + 250);
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const data = new FormData();
        data.append('targetEntity', newReqAttrs.targetEntityObj.code);
        data.append('operation',    newReqAttrs.operation);
        data.append('fileName',     newReqAttrs.fileName);
        data.append('size',         newReqAttrs.size);
        data.append('comments',     newReqAttrs.comments);
        data.append('file',         newReqAttrs.selectedFile);

        const res = await axiosAuth_DATA_MGMT_API.post("batch-data-proc-reqs", data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        resolve(res.data);

        if (res.status === 201) {
          setErrMsg_NewReqDialog('');
          setShowNewReqDialog(false);

          setNewReqAttrs({});

          // Update list
          fetchObjs(searchTerms, sortCol, sortDir, perPage, currPage);
        }

      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_NewReqDialog(t(translateAPIError(error)));
        }
      }

    });
  }


  const handleDownloadData = (req) => {

    let apiPath, fileName;

    if (req.operation === 'INSERT') {
      if (req.status === 'SUCCESS') {
        apiPath = "batch-data-proc-reqs/" + req.id + "/file?type=imp-result";
        fileName = (req.impResultUrl).slice((req.impResultUrl).lastIndexOf('/') + 1);
      } else if (req.status === 'FAILED') {
        apiPath = "batch-data-proc-reqs/" + req.id + "/file?type=error-report";
        fileName = (req.errReportUrl).slice((req.errReportUrl).lastIndexOf('/') + 1);
      } else {
        // ERROR
      }
    } else if ((req.operation === 'UPDATE') || (req.operation === 'DELETE')) {
      if (req.status === 'FAILED') {
        apiPath = "batch-data-proc-reqs/" + req.id + "/file?type=error-report";
        fileName = (req.errReportUrl).slice((req.errReportUrl).lastIndexOf('/') + 1);
      } else {
        // ERROR
      }
    } else if (req.operation === 'EXPORT') {
      if (req.status === 'SUCCESS') {
        apiPath = "batch-data-proc-reqs/" + req.id + "/file?type=exp-output";
        fileName = (req.expOutputUrl).slice((req.expOutputUrl).lastIndexOf('/') + 1);
      } else {
        // ERROR
      }
    }

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.get(apiPath, {responseType: "arraybuffer"});

        resolve(res.data);

        if (res.status === 200) {

          // Convert HEX data to binary
          const blob = new Blob([new Uint8Array(res.data)], { type: 'text/csv' });
          const blobUrl = URL.createObjectURL(blob);

          const link = document.createElement('a')

          link.href = blobUrl;
          link.download = "" + fileName + "";
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const onEntitySelect = (index) => {
    if (entityList) {
      setNewReqAttrs({ ...newReqAttrs, targetEntityObj: entityList[index]})
    }
  };

  const onOpSelect = (key, event) => {
    setNewReqAttrs({ ...newReqAttrs, operation: key })
  };


  const handleFileChange = (event) => {

    setErrMsg_NewReqDialog('');

    // Protect from Cancel event where the event.target.files[0] is not defined.
    if (event.target && event.target.files[0]) {

      // Check to see if file size exceeds limit and there is sufficient storage quota
      if (event.target.files[0].size > (docMgmtConfig.fileSizeLimit * 1024.0 * 1024.0)) {
        setErrMsg_NewReqDialog(t("I18N_ERR_File_size_exceed_limit") + docMgmtConfig.fileSizeLimit + " MB");
        return;

      } else if (event.target.files[0].name.length > 100) {
        setErrMsg_NewReqDialog(t('I18N_ERR_Max_len_file_name') + 100);
        return;

      } else if (event.target.files[0].type !== 'text/csv') {
        setErrMsg_NewReqDialog(t('I18N_ERR_Req_CSV'));
        return;
      }

      // Deep copy
      let tmpAttrs = JSON.parse(JSON.stringify(newReqAttrs));
      tmpAttrs.selectedFile = event.target.files[0];
      tmpAttrs.fileName     = event.target.files[0].name;
      tmpAttrs.size         = event.target.files[0].size;
      tmpAttrs.fileType     = event.target.files[0].type;
      tmpAttrs.fileExt      = getSubstringAfterLastPeriod(event.target.files[0].name);

      setNewReqAttrs(tmpAttrs);
    }
  };

  function getSubstringAfterLastPeriod(str) {
    const lastPeriodIndex = str.lastIndexOf('.');
    if (lastPeriodIndex === -1) {
      // No period found, return the null
      return (null);
    }
    return str.substring(lastPeriodIndex + 1);
  }



  // --- Cancel Request ---

  const handleCancelReq = (req) => {
    setCancelTarget(req);
    setShowCancelConfirmDialog(true);
  }

  function handleCancelReqCancel() {
    setCancelTarget(null);
    setShowCancelConfirmDialog(false);
  }

  function handleCancelReqSubmit() {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("batch-data-proc-reqs/" + cancelTarget.id + "/cancel");

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setShowCancelConfirmDialog(false);
          setErrMsgDeleteConfirm('');

          fetchObjs(searchTerms, sortCol, sortDir, perPage, currPage);
        }

      } catch (error) {
        setErrMsgDeleteConfirm(t(translateAPIError(error)));
      }
    });
  }


  // ----- BEGIN UI -----

  return (
    <>
      <Card className='aaa' style={{border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)', padding:'20px 40px 20px 40px', maxWidth:'2500px',
                                    height:'850px', width:'100%'}}>

        {/* ------------------------------------------------------------------------------------------------- */}

        <div style={{ height:'700px', maxHeight:'700px', marginBottom:'10px' }}>
          <div style={{ display: 'flex' }}>

            <span className={classes.admin_pages__page_title}>
              {t("I18N_Batch_data_proc_reqs")}
            </span>
            <span style={{marginLeft:'auto', marginTop:'7px', color:'rgba(200,0,0)', fontSize:'12px'}}>
              {errMsg}
            </span>

            <div style={{ display: 'flex', marginRight: '0px', width: '290px', minWidth: '260px' }}>

              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ float: 'left', marginTop: '7px', width: '120px' }} onClick={handlePurge}> {t("I18N_Purge_files")}
              </Button>

              <OverlayTrigger overlay={<Tooltip id="tooltip-new_asset" style={{fontSize:'11px'}}>{t("I18N_New_req")}</Tooltip>}>
                <span onClick={handleNewReq} style={{ marginLeft: '20px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                  <BiPlus size={18} />
                </span>
              </OverlayTrigger>

              <span style={{ marginLeft: '20px', marginRight: '0px', width: '260px' }}>
                <Form onSubmit={handleSearchSubmit}>
                  <Form.Group as={Row} >
                    <Col sm={9} style={{ marginRight: '5px' }}>
                      <div style={{ position: 'relative' }}>
                        <Form.Control style={{ fontSize: '12px' }} type="text" name="searchTerms" value={searchTerms}
                                      onChange={(e) => onInputChange(e)} placeholder={t("I18N_Search_terms")} />
                        {searchTerms && <BiXCircle size={15}
                                           style={{position:'absolute', right:'10px', top: '50%', transform:'translateY(-50%)',
                                                   cursor:'pointer', color:'#aaa'}}
                                           onClick={handleSearchClear} />}
                      </div>
                    </Col>
                    <Col sm={2} style={{ padding: '5px' }}>
                      <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip-search" style={{fontSize:'11px'}}>{t("I18N_Search")}</Tooltip>}>
                        <span onClick={handleSearchSubmit} style={{ cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                          <SearchIcon size={18} />
                        </span>
                      </OverlayTrigger>
                    </Col>
                  </Form.Group>
                </Form>
              </span>
            </div>
          </div>

          { (notFoundMsg && notFoundMsg !== '') ?
            <span className={classes.admin_pages__field_value} style={{marginTop:'20px'}}>
              {t(notFoundMsg)}
            </span>
          :
            <div style={{ overflowY:'auto', fontSize:'11px', marginTop:'10px' }}>

              { objList && objList.length > 0 ?
                <DataTable
                  columns={columns}
                  data={objList}
                  customStyles={customStyles}
                  fixedHeader
                  fixedHeaderScrollHeight={'700px'}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currPage}
                  paginationPerPage={perPage}
                  paginationRowsPerPageOptions={[20,40,100]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  onSort={handleSort}
                  sortServer
                  highlightOnHover
                  paginationComponentOptions={paginationComponentOptions}
                  noDataComponent={t("I18N_No_search_result")}
                />
              : null
              }

            </div>
          }

        </div>


        <Modal show={showNewReqDialog} onHide={handleNewReqDialogCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <span> {t("I18N_New_batch_proc_req")} </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

              <Row className={classes.admin_pages__field_label}>
                <Col> {t("I18N_Operation")}: *</Col>
                <Col> {t("I18N_Entity_to_proc")}: *</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                    title={newReqAttrs.operation ? t("I18N_" + newReqAttrs.operation) : t("I18N_Please_select") }
                    style={{ width: '180px' }}
                    onSelect={onOpSelect}>
                    {opOptions ? opOptions.map((item, index) => {
                       return (
                         <Dropdown.Item key={item.key} eventKey={item.key} className={classes.dropdown_item_wrap}>
                           { t("I18N_" + item.value) }
                         </Dropdown.Item>
                       );
                      })
                     : null
                     }
                  </DropdownButton>
                </Col>
                <Col>
                  <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                    title={newReqAttrs.targetEntityObj ? newReqAttrs.targetEntityObj.name : t("I18N_Please_select") }
                    style={{ width: '180px' }}
                    onSelect={onEntitySelect}>
                    {entityList ? entityList.map((item, index) => {
                       return (
                         <Dropdown.Item key={item.key} eventKey={index} className={classes.dropdown_item_wrap}>
                           { item.name }
                         </Dropdown.Item>
                       );
                      })
                     : null
                     }
                  </DropdownButton>
                </Col>
              </Row>

              { newReqAttrs.operation !== 'EXPORT' ?
                <>
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                    <Col>{t("I18N_File_name")}: *</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <Col sm={9}>
                      <input readOnly className={classes.admin_pages__field_editable} style={{width:'100%'}} name="fileName" value={newReqAttrs.fileName} />
                    </Col>
                    <Col sm={3}>
                      <div>
                        <input
                          type="file"
                          style={{ display: 'none' }}
                          id="fileInput"
                          onChange={handleFileChange}
                        />
                        <Button size="tiny" variant="outline-secondary" className="mb-3"
                                onClick={() => document.getElementById('fileInput').click()} >
                          {t("I18N_Choose_file")}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </>
                : null
              }

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Comments")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <textarea rows={3} className={classes.admin_pages__field_editable} style={{width:'100%'}} name="comments"
                    value={newReqAttrs && newReqAttrs.comments ? newReqAttrs.comments : ''}
                    onChange={(e) => onNewReqInputChange(e)} />
                </Col>
              </Row>

              <Row>
                <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                  {errMsg_NewReqDialog}
                </span>
              </Row>

              <Row>
                <div display='flex' style={{marginTop:'15px'}}>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ float: 'left' }}
                    onClick={handleNewReqDialogCancel}>
                    {t("I18N_Cancel")}
                  </Button>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ marginLeft: '10px' }}
                    onClick={handleNewReqDialogSubmit}>
                    {t("I18N_Submit")}
                  </Button>
                </div>
              </Row>

            </div>
          </Modal.Body>
        </Modal>

        <PurgeConfirmDialog
          title={t("I18N_Purge_files_confirm")}
          show={showPurgeConfirmDialog}
          targetName={''}
          errMsgDeleteConfirm={errMsgPurgeConfirm}
          onCancel={handlePurgeCancel}
          onSubmit={handlePurgeSubmit}
        />

        <DeleteConfirmDialog
          title={t("I18N_Req_cancel_confirm")}
          show={showCancelConfirmDialog}
          targetName={t("I18N_Req_id") + ": " + (cancelTarget ? cancelTarget.id : '')}
          errMsgDeleteConfirm={errMsgDeleteConfirm}
          onCancel={handleCancelReqCancel}
          onSubmit={handleCancelReqSubmit}
        />

      </Card>
    </>
  );
}


export default BatchDataProcAdminListView;
